import React, { FC } from 'react';
import { Drawer as DrawerCore, useScopedSelector } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { setNotificationsIsOpened } from '../../../actions/Notifications.actions';
import Sections from './Sections';

export interface DrawerProps { }

const Drawer: FC<DrawerProps> = () => {
  const isOpened: boolean = useScopedSelector('/App.features.notifications.isOpened');
  const dispatch = useDispatch();

  return (
    <DrawerCore
      name="/App.features.notifications.notificationsDrawer"
      drawerTitle="Notifications"
      isOpened={isOpened}
      position="right"
      onClose={() => dispatch(setNotificationsIsOpened())}
    >
      <Sections />
    </DrawerCore>
  );
};
export default Drawer;
